import { StoreState } from '@/redux/types';

export const selectBasketStatus = (state: StoreState) => state.basket.status;
